export const setKeysSets = keysSets => {
  return {
    type: 'SET_KEYSSETS',
    payload: keysSets,
  }
}
